
import { h, Component } from 'preact';
import style from './index.less'

export default (props)=>{
    let classes = [style.row]
    if(props.class && props.class instanceof Array){
        classes = classes.concat(props.class)
    } else {
        props.class && classes.push(props.class)
    }
    return (
        <div class={classes.join(' ')}>
            {props.children}
        </div>
    )
}


// WEBPACK FOOTER //
// ./components/elements/Row/index.js